import { TYPES } from "../actions";

const initialState = {
  trustedPersonInfos: [],
  totalCount: 0,
  currentTrustedPersonInfo: null,
  loading: false,
  error: null
};

const tkt1TrustedPersonReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get TKT1 Trusted Person Infos
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_SUCCESS:
      return {
        ...state,
        trustedPersonInfos: action.payload.data.result || [],
        totalCount: action.payload.data.totalCount || 0,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_FAIL:
      return {
        ...state,
        trustedPersonInfos: [],
        loading: false,
        error: action.payload
      };

    // Get TKT1 Trusted Person Info by ID
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_SUCCESS:
      return {
        ...state,
        currentTrustedPersonInfo: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_FAIL:
      return {
        ...state,
        currentTrustedPersonInfo: null,
        loading: false,
        error: action.payload
      };

    // Get TKT1 Trusted Person Info by MID
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_SUCCESS:
      return {
        ...state,
        currentTrustedPersonInfo: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_FAIL:
      return {
        ...state,
        currentTrustedPersonInfo: null,
        loading: false,
        error: action.payload
      };

    // Create TKT1 Trusted Person Info
    case TYPES.ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS:
      return {
        ...state,
        trustedPersonInfos: [action.payload.data, ...state.trustedPersonInfos],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    case TYPES.ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update TKT1 Trusted Person Info
    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS:
      return {
        ...state,
        trustedPersonInfos: state.trustedPersonInfos.map(item =>
          item._id === action.payload.data._id ? action.payload.data : item
        ),
        currentTrustedPersonInfo: state.currentTrustedPersonInfo && state.currentTrustedPersonInfo._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentTrustedPersonInfo,
        loading: false,
        error: null
      };
    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete TKT1 Trusted Person Info
    case TYPES.ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_SUCCESS:
      return {
        ...state,
        trustedPersonInfos: state.trustedPersonInfos.filter(item => item._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentTrustedPersonInfo: state.currentTrustedPersonInfo && state.currentTrustedPersonInfo._id === action.payload.id 
          ? null 
          : state.currentTrustedPersonInfo,
        loading: false,
        error: null
      };
    case TYPES.ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default tkt1TrustedPersonReducer;